import styles from "./OfferClaimRibbon.module.css";

export const OfferClaimRibbon = ({
    offersClaimed,
}: {
    offersClaimed: number;
}): React.ReactElement => {
    const offersClaimedString: string = offersClaimed.toLocaleString();

    return (
        <section id="offerClaimRibbon">
            <div className={styles.offerClaimRibbon}>
                <div className={styles.claimText}>
                    &#9889;&#xFE0E;&nbsp;
                    {`${offersClaimedString} OFFERS CLAIMED!`}
                    &nbsp;&#9889;&#xFE0E;
                </div>
            </div>
        </section>
    );
};
